<template>
  <div>
    <!-- 编辑描述窗口 -->
    <EditDescription
      v-if="editDesVisible"
      @cancel="hideEditDesView"
      @edit="changeDes"
    />
    <!-- 操作按钮 -->
    <a-dropdown :trigger="['hover']" placement="topRight">
      <a-button
        icon="menu"
        size="large"
        style="position:absolute; bottom:1rem;right:28rem; z-index: 10;"
      />
      <a-menu slot="overlay">
        <a-menu-item key="nomargin" @click="togglMargin">
          <a-icon type="column-height" v-if="nomargin" />
          <a-icon type="vertical-align-middle" v-else />
          {{ nomargin ? "开启" : "关闭" }}间隔
        </a-menu-item>
        <a-menu-item key="export" @click="exportData">
          <a-icon type="export" />导出数据
        </a-menu-item>
        <a-menu-item key="uploadData">
          <a-icon type="upload" />
          <a-upload
            name="file"
            :before-upload="beforeUpdate"
            :showUploadList="false"
            @change="handleChange"
            >导入数据
          </a-upload>
        </a-menu-item>
        <!-- <a-menu-item key="addDescription" @click="showEditDesView">
          <a-icon type="file-text" />添加描述
        </a-menu-item> -->

        <a-menu-item key="deleteRecord" @click="delRecord">
          <a-icon type="delete" />删除记录
        </a-menu-item>
        <a-menu-item key="unselect" @click="unselect">
          <a-icon type="close-square" />取消选择
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import EditDescription from "./BlockEditDes";
import iojson from "iojson";
import moment from "moment";

export default {
  props: ["nomargin"],
  components: {
    EditDescription
  },
  data() {
    return {
      editDesVisible: false
    };
  },
  computed: {
    ...mapGetters([
      "hasChosen",
      "selectedBlocks",
      "blocksState",
      "setting",
      "events",
      "categorys",
      "setting"
    ])
  },
  methods: {
    hideEditDesView() {
      this.editDesVisible = false;
    },
    showEditDesView() {
      //检查是否有选中块
      if (!this.hasChosen) {
        this.$message.error("未选择块");
        return;
      }
      let hasNullBlock = false;

      //检查是否有无记录的块
      const blocks = this.selectedBlocks;
      for (let key of Object.keys(blocks)) {
        if (!this.blocksState[key]) {
          hasNullBlock = true;
          break;
        }
      }

      if (hasNullBlock) {
        this.$message.error("有未标记的块");
        return;
      }

      this.editDesVisible = true;
    },
    togglMargin() {
      this.$emit("togglMargin");
    },
    changeDes(value) {
      this.editDesVisible = false;
      if (value.trim() === "") {
        value = undefined;
      }

      this.setDes(value);
    },
    async exportData() {
      // let dataOut = JSON.stringify(this.events);
      const events = this.events;
      const categorys = this.categorys;
      const logs = await this.getLogsAll();
      const setting = this.setting;
      const data = { events, categorys, logs, setting };
      let dataOut = btoa(encodeURIComponent(JSON.stringify(data)));

      iojson.exportJSON(
        dataOut,
        `AikaData - ${moment().format("YYYY-MM-DD HH:mm:ss")}.json`
      );
    },
    beforeUpdate() {
      return false;
    },
    handleChange(info) {
      if (info.file.status !== "uploading") {
        // console.log(info.file, info.fileList);
        try {
          let reader = new FileReader();
          reader.onload = event => {
            try {
              let config = JSON.parse(event.target.result);
              //%3A = "  %2C = , %23 = #
              const data = JSON.parse(
                decodeURI(decodeURI(atob(config)))
                  .replace(/%3A/g, ":")
                  .replace(/%2C/g, ",")
                  .replace(/%23/g, "#")
              );
              const promise = [];

              promise.push(this.setLogsByFile(data.logs));
              promise.push(this.setCategorysByFile(data.categorys));
              promise.push(this.setEventsByFile(data.events));
              promise.push(this.setSettingByFile(data.setting));

              Promise.all(promise).then(() => {
                this.$message.success(`数据导入成功`);
                setTimeout(() => this.$router.go(0), 800);
              });

              return config;
            } catch (e) {
              this.$message.error(`${info.file.name} 导入失败.`);
              throw new Error(e);
            }
          };
          reader.readAsText(info.file);
        } catch (e) {
          this.$message.error(`${info.file.name} 导入失败.`);
          console.error(e);
        }
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} 导入成功`);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 导入失败.`);
      }
    },
    ...mapActions([
      "delRecord",
      "unselect",
      "setDes",
      "getLogsAll",
      "setLogsByFile",
      "setCategorysByFile",
      "setEventsByFile",
      "setSettingByFile"
    ])
  }
};
</script>
